import { Stack, Text } from "@mantine/core";
import type { Veraeusserungsform } from "../../../types/api.types";
import { getVeraeusserungsformLabel } from "./MarketingTypeTable.constants";

interface MarketingTypeEditModalContentProps {
  oldVeraeusserungsform: Veraeusserungsform;
  newVeraeusserungsform: Veraeusserungsform;
}

export function MarketingTypeEditModalContent({
  oldVeraeusserungsform,
  newVeraeusserungsform
}: MarketingTypeEditModalContentProps) {
  if (newVeraeusserungsform === "feste_einspeiseverguetung") {
    return (
      <Stack gap="md">
        <Text>
          Möchten Sie die Veräußerungsform auf &bdquo;Feste
          Einspeisevergütung&ldquo; ändern?
        </Text>
        <Text>
          Bei dieser Veräußerungsform sind am Vertrag Angaben zum Vermarkter und
          zur Vergütung nicht zulässig. Bestehende Einträge in diesen Feldern
          werden in allen betroffenen Vermarktungsverträgen automatisch
          gelöscht.
        </Text>
      </Stack>
    );
  }

  if (oldVeraeusserungsform === "feste_einspeiseverguetung") {
    return (
      <Stack gap="md">
        <Text>
          Möchten Sie die Veräußerungsform auf &bdquo;
          {getVeraeusserungsformLabel(newVeraeusserungsform)}&ldquo; ändern?
        </Text>
        <Text>
          Bei dieser Veräußerungsform sind am Vermarktungsvertrag einige
          Informationen zu hinterlegen. Ein aktuell hinterlegter Vertrag zur
          Festen Einspeisevergütung wird gelöscht. Sie müssen in Gänze einen
          neuen Vertrag einpflegen.
        </Text>
      </Stack>
    );
  }

  return (
    <Stack gap="md">
      <Text>
        Möchten Sie die Veräußerungsform auf &bdquo;
        {getVeraeusserungsformLabel(newVeraeusserungsform)}&ldquo; ändern?
      </Text>
      <Text>
        Bitte prüfen Sie im Nachgang Ihre Angaben auf einem bereits angelegten
        Vermarktungsvertrag.
      </Text>
    </Stack>
  );
}
